import { Component,Input, OnChanges, SimpleChanges} from "@angular/core";
import { ChangeDetectorRef, inject } from '@angular/core';
import { Toast } from "../../model/toast";


@Component({
    standalone:true,
    selector:'app-toast',
    imports:[],
    templateUrl: "./toast-component.html",
    styleUrl: "./toast-component.css",
})

export class ToastComponent implements OnChanges{
    @Input() toast?: Toast

    private cdr = inject(ChangeDetectorRef);
    private hideTimer?: ReturnType<typeof setTimeout>

    isVisible = false;
    isErrorInfoVisible = false;
    duration = 5000;
    animationD = this.duration-500;

    iconMap:Record<Toast['type'], string> = {
        success: 'assets/icons/toast/dog-success.svg',
        error: 'assets/icons/toast/dog-error.svg',
        warning: 'assets/icons/toast/dog-warning.svg',
        info: 'assets/icons/toast/dog-info.svg'
      };

      statusLabels = {
        success: 'Klart',
        error: 'Avbrott',
        warning: 'Varning',
        info: 'Info'
      };

    ngOnChanges(changes: SimpleChanges): void {
        clearTimeout(this.hideTimer);
        if(changes['toast'] && this.toast){
            this.isVisible = false;
        }

        this.duration = this.toast?.duration ?? 5000

        setTimeout(()=>{
            this.isVisible = true;
            this.cdr.markForCheck();
        },500);

        this.hideTimer = setTimeout(() =>{
            this.isVisible = false
            this.cdr.markForCheck();
        },this.duration);
    }
}